export default __webpack_public_path__ + "static/media/react-rout.e544f0be.png";